<template> <!-- 色変更(黄) 子コンポーネント -->
  <div id="setyellow" >
    <td :style="{background:yellow[0]}" height="55" @click="setYellow(0)"></td>
    <td :style="{background:yellow[1]}" @click="setYellow(1)"></td>
    <td :style="{background:yellow[2]}" @click="setYellow(2)"></td>
    <td :style="{background:yellow[3]}" @click="setYellow(3)"></td>
    <td :style="{background:yellow[4]}" @click="setYellow(4)"></td>
    <td :style="{background:yellow[5]}" @click="setYellow(5)"></td>
    <td :style="{background:yellow[6]}" @click="setYellow(6)"></td>
    <td :style="{background:yellow[7]}" @click="setYellow(7)"></td>
    <td :style="{background:yellow[8]}" @click="setYellow(8)"></td>
    <td :style="{background:yellow[9]}" @click="setYellow(9)"></td>
    <td :style="{background:yellow[10]}" @click="setYellow(10)"></td>
    <td :style="{background:yellow[11]}" @click="setYellow(11)"></td>
    <td :style="{background:yellow[12]}" @click="setYellow(12)"></td>
    <td :style="{background:yellow[13]}" @click="setYellow(13)"></td>
    <td :style="{background:yellow[14]}" @click="setYellow(14)"></td>
  </div>
</template>

<script>
export default {
  name: 'SetYellow',
  props: {
    yellow: Array,
    index: Number
  },
  data () {
    return {
      bg_color: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']
    }
  },

  methods: {
    setYellow: function (num) {
      this.$emit('set-yellow', num, this.index)
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
